export default __webpack_public_path__ + "static/media/circularDownArr.ac8a0991.svg";